import React, { useState } from "react";
import { Field } from "formik";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { AccountPopupField, AccountPopupSaveFooter } from "./accountPopupFields";

const BusinessDetailsPopup = ({ isOpen, onClose, setFieldValue, values, errors, initialStep = 0 }) => {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const sampleData = {
    businessName: "Acme Plumbing Services",
    industry: "Plumbing",
    abn: "12 345 678 901",
  };

  const displayValues = {
    businessName:
      values.businessName && values.businessName.trim() !== ""
        ? values.businessName
        : sampleData.businessName,
    industry:
      values.industry && values.industry.trim() !== "" ? values.industry : sampleData.industry,
    abn: values.abn && values.abn.trim() !== "" ? values.abn : sampleData.abn,
  };

  const steps = [
    {
      title: "Business Name",
      field: "businessName",
      placeholder: "Acme Plumbing",
      inputType: "text",
    },
    {
      title: "ABN",
      field: "abn",
      placeholder: "12 345 678 901",
      inputType: "text",
    },
    {
      title: "Trade category",
      field: "industry",
      type: "dropdown",
      options: [
        { label: "Plumbing", value: "Plumbing" },
        { label: "Electrical", value: "Electrical" },
        { label: "HVAC", value: "HVAC" },
        { label: "Carpentry", value: "Carpentry" },
        { label: "Painting", value: "Painting" },
        { label: "Landscaping", value: "Landscaping" },
        { label: "Roofing", value: "Roofing" },
        { label: "Flooring", value: "Flooring" },
        { label: "Other", value: "Other" },
      ],
    },
  ];

  const currentStepData = steps[currentStep];

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Field name={currentStepData.field}>
                {({ form }) => (
                  <AccountPopupField
                    step={currentStepData}
                    fieldKey={currentStepData.field}
                    value={displayValues[currentStepData.field]}
                    onChange={(v) => setFieldValue(currentStepData.field, v)}
                    form={form}
                  />
                )}
              </Field>
              <AccountPopupSaveFooter onClick={onClose} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default BusinessDetailsPopup;
